import React, {ReactNode, useEffect} from "react";
import {usePrefs} from "hooks/usePrefs";
import AwsuiDarkMode from "awsui-dark-mode";


interface DarkModeContainerProps {
    children: ReactNode;
}

const DarkModeContainer: React.FC<DarkModeContainerProps> = ({children}) => {

    const [{darkModeEnabled}] = usePrefs();

    useEffect(() => {
        if (darkModeEnabled) {
            document.body.setAttribute("data-theme", "dark");
        } else {
            document.body.setAttribute("data-theme", "light");
        }
    }, [darkModeEnabled]);

    return (
        <AwsuiDarkMode disabled={!darkModeEnabled}>
            {children}
        </AwsuiDarkMode>
    );
};

export default DarkModeContainer;
